import { View } from './server/view';

export class FolderTabInfos {
    /**
     * Constructeur.
     * @param folderId : Id du dossier.
     * @param folderName : Nom du dossier.
     * @param view : id de la vue à laquelle appartient le dossier.
     * @param readonly : Valeur indiquant si le détail du dossier doit être affiché en lecture seule.
     */
    public constructor(
        public folderId: string,
        public folderName: string,
        public view: View,
        public readonly: boolean
    ) {}
}
